"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typesMap = exports.stylesMap = void 0;
var LabelProps_1 = require("./LabelProps");
var styles = require("./Label.css");
exports.stylesMap = new Map([
    [LabelProps_1.LabelSizes.NONE, null],
    [LabelProps_1.LabelSizes.XSMALL, styles.xsmall],
    [LabelProps_1.LabelSizes.SMALL, styles.small],
    [LabelProps_1.LabelSizes.MEDIUM, styles.medium],
    [LabelProps_1.LabelSizes.LARGE, styles.medium],
    [LabelProps_1.LabelSizes.XLARGE, styles.xlarge],
    [LabelProps_1.LabelSizes.HUGEHEADING, styles.hugeHeading],
    [LabelProps_1.LabelSizes.LARGEHEADING, styles.largeHeading],
    [LabelProps_1.LabelSizes.FEATUREDPRICE, styles.featuredPrice],
    [LabelProps_1.LabelSizes.MEDIUMHEADING, styles.mediumHeading],
    [LabelProps_1.LabelSizes.MEDIUMHEADINGALTERNATE, styles.mediumHeadingAlternate],
    [LabelProps_1.LabelSizes.SMALLHEADING30, styles.smallHeading30],
    [LabelProps_1.LabelSizes.SMALLHEADING24, styles.smallHeading24],
    [LabelProps_1.LabelSizes.SMALLHEADING24ALTERNATE, styles.smallHeading24Alternate],
    [LabelProps_1.LabelSizes.SMALLHEADING18, styles.smallHeading18],
    [LabelProps_1.LabelSizes.SMALLHEADING15, styles.smallHeading15],
    [LabelProps_1.LabelSizes.LARGEBODY, styles.largeBody],
    [LabelProps_1.LabelSizes.LARGEBODYITALIC, styles.largeBodyItalic],
    [LabelProps_1.LabelSizes.LARGEBODYALTERNATE, styles.largeBodyAlternate],
    [LabelProps_1.LabelSizes.EYEBROWLARGE, styles.eyebrowLarge],
    [LabelProps_1.LabelSizes.MEDIUMBODY, styles.mediumBody],
    [LabelProps_1.LabelSizes.MEDIUMBODYITALIC, styles.mediumBodyItalic],
    [LabelProps_1.LabelSizes.MEDIUMBODYALTERNATE, styles.mediumBodyAlternate],
    [LabelProps_1.LabelSizes.EYEBROWSMALL, styles.eyebrowSmall],
    [LabelProps_1.LabelSizes.SMALLBODY, styles.smallBody],
    [LabelProps_1.LabelSizes.SMALLBODYITALIC, styles.smallBodyItalic],
    [LabelProps_1.LabelSizes.LEGALCOPY, styles.legalCopy],
    [LabelProps_1.LabelSizes.LABEL15WTNORMAL, styles.label15WtNormal],
    [LabelProps_1.LabelSizes.LABEL15WT500, styles.label15Wt500],
    [LabelProps_1.LabelSizes.LABEL18WTNORMAL, styles.label18WtNormal],
    [LabelProps_1.LabelSizes.LABEL18WT500, styles.label18Wt500],
    [LabelProps_1.LabelSizes.LABEL22WT500, styles.label22Wt500],
    [LabelProps_1.LabelSizes.LABEL34WT500, styles.label34Wt500],
]);
exports.typesMap = new Map([
    [LabelProps_1.LabelTypes.SUCCESS, styles.success],
]);
//# sourceMappingURL=LabelStylesMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Label/LabelStylesMaps.js
// module id = 1038
// module chunks = 8